export enum SquareIntegrationsErrorBannerMessages {
  ERROR_MESSAGE_START_PAUSE_ORDERS = 'There was an issue sending/pausing your orders. Please try again.',
  ERROR_MESSAGE_DISABLE_INTEGRATION = 'There was an issue disabling the integration. Please try again.',
}
